import { Check, Package, MapPin, Truck } from "lucide-react";

const Step = ({
  icon: Icon,
  label,
  value,
  status, // completed | active | pending
  isLast
}) => {
  return (
    <div className="flex items-center w-full">
      {/* Circle */}
      <div
        className={`relative z-10 flex items-center justify-center w-10 h-10 rounded-full border-2
          ${
            status === "completed"
              ? "bg-green-500 border-green-500 text-white"
              : status === "active"
              ? "bg-white border-blue-600 text-blue-600 animate-pulse"
              : "bg-white border-gray-300 text-gray-400"
          }`}
      >
        {status === "completed" ? <Check size={18} /> : <Icon size={18} />}
      </div>

      {/* Label */}
      <div className="ml-3">
        <div
          className={`text-sm font-semibold ${
            status === "completed"
              ? "text-green-600"
              : status === "active"
              ? "text-blue-600"
              : "text-gray-400"
          }`}
        >
          {label}
        </div>
        <div className="text-xs text-gray-500">{value}</div>
      </div>

      {/* Connector */}
      {!isLast && (
        <div className="flex-1 mx-4 h-[3px] rounded bg-gray-200 relative overflow-hidden">
          <div
            className={`absolute left-0 top-0 h-full transition-all duration-700
              ${
                status === "completed"
                  ? "w-full bg-green-500"
                  : status === "active"
                  ? "w-1/2 bg-blue-500"
                  : "w-0"
              }`}
          />
        </div>
      )}
    </div>
  );
};

const DeliveryProgressBar = ({
  pickupsCompleted,
  pickupsTotal,
  dropoffsCompleted,
  dropoffsTotal,
  delivered
}) => {
  const pickupStatus =
    pickupsCompleted === pickupsTotal ? "completed" : "active";

  const dropoffStatus =
    pickupsCompleted === pickupsTotal
      ? dropoffsCompleted === dropoffsTotal
        ? "completed"
        : "active"
      : "pending";

  const deliveredStatus = delivered ? "completed" : "pending";

  return (
    <div className="w-full bg-white border border-gray-200 rounded-xl p-4 shadow-sm">
      <div className="flex items-center justify-between">
        <Step
          icon={Package}
          label="Pickups"
          value={`${pickupsCompleted}/${pickupsTotal}`}
          status={pickupStatus}
        />

        <Step
          icon={MapPin}
          label="Dropoffs"
          value={`${dropoffsCompleted}/${dropoffsTotal}`}
          status={dropoffStatus}
        />

        <Step
          icon={Truck}
          label="Delivered"
          value="1"
          status={deliveredStatus}
          isLast
        />
      </div>
    </div>
  );
};

export default DeliveryProgressBar;
